// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cW","homeContent__bottom":"c-i_cX","homeContent__cardHolder":"c-i_cY","homeContent__seoTextHolder":"c-i_cZ"};